__turbopack_context__.v({
  "action": "EJ4Mza_action",
  "avatar": "EJ4Mza_avatar",
  "encyclo-article": "EJ4Mza_encyclo-article",
  "encyclopedia-category": "EJ4Mza_encyclopedia-category",
  "rating": "EJ4Mza_rating",
  "review": "EJ4Mza_review",
  "review-list": "EJ4Mza_review-list",
  "social-proof": "EJ4Mza_social-proof",
  "trustpilot": "EJ4Mza_trustpilot",
  "trustpilot-card": "EJ4Mza_trustpilot-card",
  "trustpilot-container": "EJ4Mza_trustpilot-container",
  "what-section": "EJ4Mza_what-section",
});
